import React, { useEffect, useMemo, useState } from "react";
import { AgGridReact } from "ag-grid-react";
import { Pagination, Select, Button, ConfigProvider, PaginationProps, Tooltip } from "antd";
import { DownloadOutlined } from "@ant-design/icons";

import { Link, useLocation, useNavigate } from "react-router-dom";
import { ColDef } from "ag-grid-community";
import viVN from 'antd/locale/vi_VN';



import './Customers.scss';
import Layout from "../../Layout";
import BreadcrumbBlock from "../../components/BreadcrumbBlock/BreadcrumbBlock";
import { CustomLoadingOverlayTable, dataPagination, formatPrice, getWidthFromHeaderV2 } from "../../until";
import { formatNumber } from "../../services/mixin";
import useDebounce from "../../hook/useDebounce";
import { getListCustomerVehicleOwnershipReportByBrand } from "../../api/reportCustomer/reportCustomerApi";
import { LIMIT_EXPORT_EXCEL, NO_DATA } from "../../env";
import useToast from "../../hook/useToast";
import useLoading from "../../hook/useLoading";
import { NodataTable } from "../../components/NoDataTable";
import { IDataDefaulFilter } from "./ReportCustomer";





export interface CustomerRow {
    id: number;
    customerCode: string;
    fullName: string;
    customerType: string;
    gender: string;
    phone: string;
    birthday: string;
    district: string;
    province: string;
}



const getFieldValue = (
    fields: any[],
    fieldCode: string
) => {
    return fields.find(
        item => item.fieldCode === fieldCode
    )?.value;
};

const defaultColDef = {
    resizable: true,
    flex: 1,
    valueFormatter: (params: any) =>
        params.value && String(params.value).trim() !== ""
            ? params.value
            : NO_DATA,

};
export const mapCustomerData = (data: any[]): CustomerRow[] => {
    return data.map(item => ({
        id: item.id,
        customerCode: item.code,
        fullName: getFieldValue(item.fields, 'cus_name') || '',
        customerType: getFieldValue(item.fields, 'cus_type_name') || '',
        gender: getFieldValue(item.fields, 'cus_gender_name') || '',
        phone: getFieldValue(item.fields, 'cus_tel') || '',
        birthday: getFieldValue(item.fields, 'cus_birth_day') || '',
        district: getFieldValue(item.fields, 'cus_ward') || '',
        province: getFieldValue(item.fields, 'cus_city') || '',
    }));
};


const ReportCustomerDetail = () => {
    const navigate = useNavigate()

    const location = useLocation();


    const {
        brandId,
        dataFilter,
        unitIdDefault,
        type,
        brandName
    } = location?.state ?? {}




    const pushToast = useToast()
    const pushLoading = useLoading()
    const [currentPage, setCurrentPage] = useState(6);
    const [pageSize, setPageSize] = useState(15);
    const [loadingTable, setLoadingTable] = useState(false);

    const total = 1275; // tổng record
    const [pagination, setPagination] = useState({ current: 1, pageSize: 20, total: 0 });
    const [dataVehicleOwnershipReportByBrandTable, setDataVehicleOwnershipReportByBrandTable] = useState<any[]>([])

    const columnDefs: ColDef<CustomerRow>[] = [
        {
            headerName: 'Mã định danh khách hàng',
            field: 'customerCode',
            minWidth: getWidthFromHeaderV2("Mã định danh khách hàng"),
        },
        {
            headerName: 'Họ và tên',
            field: 'fullName',
            minWidth: getWidthFromHeaderV2("Họ và tên"),
            cellRenderer: (params: any) => {
                const { id, fullName } = params?.data
                return (
                    <Tooltip
                        placement="right"
                        color="white"
                        title={
                            <span className="custom-page-css " style={{ color: "#000", textTransform: 'capitalize' }}>
                                {fullName}
                            </span>
                        }
                    >
                        <Link
                            style={{
                                color: "#1890ff",
                                textTransform: 'capitalize'
                            }}
                            to={`/customer/list/edit`}
                            state={{
                                firstPage: location.pathname,
                                id: id,
                                brandId,
                                dataFilter,
                                unitIdDefault,
                                type,
                                brandName

                            }}
                        >
                            {fullName}
                        </Link>
                    </Tooltip>

                )
            },
        },
        {
            headerName: 'Loại khách hàng',
            field: 'customerType',
            minWidth: getWidthFromHeaderV2("Loại khách hàng"),
        },
        {
            headerName: 'Giới tính',
            field: 'gender',
            width: getWidthFromHeaderV2("Giới tính"),
        },
        {
            headerName: 'Số điện thoại',
            field: 'phone',
            minWidth: getWidthFromHeaderV2("Số điện thoại"),
        },
        {
            headerName: 'Ngày sinh',
            field: 'birthday',
            minWidth: getWidthFromHeaderV2("Ngày sinh"),
        },
        {
            headerName: 'Quận/Huyện',
            field: 'district',
            minWidth: getWidthFromHeaderV2("Quận/Huyện"),
        },
        {
            headerName: 'Tỉnh thành',
            field: 'province',
            minWidth: getWidthFromHeaderV2("Tỉnh thành"),
        },
    ];


    const gListCustomerVehicleOwnershipReportByBrand = useDebounce(async (pageCurent: number = 1, pageSize: number = 10,) => {
        if (!brandId) {
            navigate(-1)
            return
        }
        setLoadingTable(true)
        const result = await getListCustomerVehicleOwnershipReportByBrand(
            pageSize,
            pageCurent,
            brandId,
            type,
            unitIdDefault,
            dataFilter
        )
        if (result?.status) {
            setPagination({ current: pageCurent, pageSize, total: result?.total })
            // setDataCarOwnedBrandByUnit(formatVehicleOwnershipChart(resultCarOwnedBrandByUnit.data))
            setDataVehicleOwnershipReportByBrandTable(mapCustomerData(result?.data))

        } else {
            pushToast(result?.message, "error")
            navigate(-1)
        }
        setLoadingTable(false)
    }, 1000)


    const onPaginationChange: PaginationProps['onChange'] = (pageNumber, pageSize) => {
        setPagination((prev) => ({ ...prev, current: pageNumber, pageSize }))
        gListCustomerVehicleOwnershipReportByBrand(pageNumber, pageSize)
    }



    useEffect(() => {
        gListCustomerVehicleOwnershipReportByBrand()
    }, [])


    const convertTitle = (typeTmp: number, brandNameTmp: string) => {
        switch (typeTmp) {
            case 6:
                return `Khách hàng sở hữu 6-10 xe thương hiệu ${brandNameTmp}`
            case 7:
                return `Khách hàng sở hữu > 10 xe thương hiệu ${brandNameTmp}`
            case 8:
                return `Tổng khách hàng sở hữu xe thương hiệu ${brandNameTmp}`
            default:
                return `Khách hàng sở hữu ${typeTmp} xe thương hiệu ${brandNameTmp}`
        }
    }

    return (
        <Layout contentClassName='arc-content'>

            <BreadcrumbBlock
                backLink="/analysis-report/customers" //"/customer/list/edit
                items={[
                    { title: <Link to="/">THACO AUTO CRM</Link>, },
                    { title: 'Báo cáo phân tích', },
                    { title: 'Tổng quan khách hàng', },
                    { title: 'Danh sách khách hàng', },
                ]}
                title={`Danh sách khách hàng (${formatPrice(pagination.total)})`}
            />
            <div className="custom-page-css flex flex-col flex-1 justify-between report-customer-detail bg-white  rounded-lg">
                <div className="custom-page-css flex flex-col gap-2">
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            marginBottom: 16,
                        }}
                    >
                        <h3
                            style={{
                                fontSize: 16,
                                fontWeight: 500,
                                margin: 0,
                            }}
                        >
                            {convertTitle(type, brandName)}
                        </h3>

                        <Button icon={<DownloadOutlined />}>
                            Xuất báo cáo
                        </Button>
                    </div>

                    <div className="report-ag-table">
                        <div className="ag-theme-alpine" style={{ width: '100%' }}>
                            <AgGridReact
                                rowData={dataVehicleOwnershipReportByBrandTable}
                                columnDefs={columnDefs}
                                defaultColDef={defaultColDef}
                                loading={loadingTable}
                                loadingOverlayComponent={CustomLoadingOverlayTable}
                                domLayout="autoHeight"
                                rowHeight={48}
                                getRowStyle={(params: any) => ({
                                    backgroundColor: params.node.rowIndex % 2 === 0 ? '#ffffff' : '#F8F8F8',
                                })}
                                suppressMovableColumns
                                overlayNoRowsTemplate={NodataTable}
                                suppressCellFocus
                            />
                        </div>
                    </div>
                </div>

                <ConfigProvider locale={viVN}>
                    <div className="pagination-block">
                        <Pagination
                            className='rs-pagination'
                            showSizeChanger
                            current={pagination.current}
                            pageSize={pagination.pageSize}
                            total={pagination.total}
                            pageSizeOptions={[10, 20, 50, 100]}
                            itemRender={(page, type, originalElement) => {
                                // Chỉ custom khi là nút số trang
                                if (type === 'page') {
                                    return <span>{formatNumber(page)}</span>;
                                }
                                // prev / next / jump-prev / jump-next giữ nguyên
                                return originalElement;
                            }}
                            showTotal={(total) => `Tổng cộng ${dataPagination(pagination.total, pagination.pageSize, pagination.current).totalPage} trang`}
                            onChange={onPaginationChange}
                        />
                    </div>
                </ConfigProvider>
            </div>
        </Layout>
    );
};

export default ReportCustomerDetail;